import React, { useEffect, useState } from "react";
import BackButton from "../bars/BackButton";
import LocationSvg from "../../pages/profile/icons/location.svg";
import calendarSvg from "../../pages/profile/icons/calender.svg";
import ticketSvg from "../../images/tickets.svg";
import { formatEventDateTime, formatEventDuration, formatEventStartingDate, handleOffers, setEventLinkRedirect } from "../../utils/util";
import RedirectCommonModal from "../../components/alert/RedirectCommonModal";
import { RWebShare } from "react-web-share";
import ShareIcon from "./images/share.svg"
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAppUserId, setEventRedirect } from "../../slices/LayoutSlice";
import { baseURL } from "../../constants/Api";
function EventDetails(props) {
  const { eventData, remainingTickets } = props;
  const appUserIdFromStore = useSelector((store) => store.layout.appUserId);
  const appUserId = localStorage.getItem("appUserId") ? localStorage.getItem("appUserId") : appUserIdFromStore;
  const [popUp, setPopUp] = useState(false)
  const currentUrl = window.location.href;
  const location = useLocation()
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const eventRedirectLink = useSelector((store) => store?.layout?.eventRedirect);

//  useEffect(()=>{
//   console.log("object",location?.pathname)
//   if(appUserId){
//     // dispatch(setEventRedirect(""))
//     setEventLinkRedirect("");
  //  useEffect(()=>{
  //   console.log("object",location?.pathname)
  //   if(appUserId){
  //     // dispatch(setEventRedirect(""))
  //     setEventLinkRedirect("");

//   }else{
//     setEventLinkRedirect(`${baseURL}/event-details/${item?.id}/${item?.slug}`)
//     // dispatch(setEventRedirect(`..${location?.pathname}`))
//   }
//   },[])
  //   }else{
  //     setEventLinkRedirect(`${baseURL}/event-details/${item?.id}/${item?.slug}`)
  //     // dispatch(setEventRedirect(`..${location?.pathname}`))
  //   }
  //   },[])

  // const handleGetTickets = ()=>{
  //   console.log("object")
  // const handleGetTickets = ()=>{
  //   console.log("object")

  //   console.log(appUserId, appUserIdFromStore)
  //   if(appUserId){
  //     console.log("object")
  //     dispatch(setEventRedirect(""))
  //     props.goToEvent()
  //     console.log(appUserIdFromStore)
  //   }else{
  //     // setPopUp(true)
  //     console.log(location?.pathname)
  //       //  dispatch(setEventRedirect(`..${location?.pathname}`))
  //        setEventLinkRedirect(`${baseURL}/event-details/${item?.id}/${item?.slug}`)
  //   console.log(appUserId, appUserIdFromStore)
  //   if(appUserId){
  //     console.log("object")
  //     dispatch(setEventRedirect(""))
  //     props.goToEvent()
  //     console.log(appUserIdFromStore)
  //   }else{
  //     // setPopUp(true)
  //     console.log(location?.pathname)
  //       //  dispatch(setEventRedirect(`..${location?.pathname}`))
  //        setEventLinkRedirect(`${baseURL}/event-details/${item?.id}/${item?.slug}`)

  //        navigate(`../login`, {state:{
  //         source:`..${location?.pathname}`
  //        }})
 
  //   }
  // }
  //        navigate(`../login`, {state:{
  //         source:`..${location?.pathname}`
  //        }})

  //   }
  // }

  // useEffect(()=>{
  //   console.log(appUserIdFromStore,eventRedirectLink)
  //   if(eventRedirectLink && !appUserIdFromStore){
  //   }
  // },[eventRedirectLink])

  return (
    // <div className="pt-4 h-full relative event-data">
    //   <div className="section-wrap flex items-center w-full justify-between mb-4">
    //     <div className="flex items-center gap-3">
    //     <BackButton link="../"/>
    //     <div className="event-heading">Event</div>
    //     </div> 
    //     <RWebShare
    //       data={{
    //         // text: "Edaya Explore",
    //         url: currentUrl,
    //         // title: "Edaya | Guest Web App",
    //       }}
    //       onClick={() => console.log("shared successfully!")}
    //     >
    //     <button className="bg-white text-black px-3 text-sm py-2 flex items-center gap-3 rounded-2xl">Share <img className="w-4" src={ShareIcon} alt="" /></button>
    //   </RWebShare>
    //   </div>
    //   <div
    //     className="h-[240px] section-wrap w-full mx-auto sm:h-[300px] bg-cover bg-no-repeat"
    //     style={{
    //       background:
    //       eventData?.image ?
    //         `url(${eventData?.image})` : "gray",
    //         backgroundSize:"cover",
    //         backgroundRepeat:"no-repeat",
    //         maxWidth:"1334px", 
    //      }}
    //   ></div>
    //   <div className="mt-3 section-wrap pb-32">
    //     <div className="date-starting">{formatEventStartingDate(eventData?.from)}</div>
    //     <div className="event-main-head mt-2">
    //     {eventData?.name}
    //     </div>
    //     <div className="mt-4 flex gap-3">
    //       <img className="h-fit mt-1" src={calendarSvg} alt="" />
    //       <div className="date-starting" style={{fontSize:"14px"}}>{formatEventDateTime(eventData?.from)}<br/>
    //         <span>({formatEventDuration(eventData?.from,eventData?.to)})</span>
    //       </div>
    //      </div>
    //     <div className="mt-4 flex gap-3">
    //       <img className="h-fit mt-1" src={LocationSvg} alt="" />
    //       <div className="date-starting" style={{fontSize:"14px"}}>{eventData?.hotelName}</div>
    //     </div>
    //     <div className="mt-4 flex gap-3">
    //       <img className="h-fit w-5" src={ticketSvg} alt="" />
    //       <div className="date-starting" style={{fontSize:"14px"}}>Remaining Tickets: {remainingTickets}</div>
    //     </div>
    //    {eventData?.description && <div className="mt-4">
    //       <div className="sub-head">About this Event </div>
          
    //       <p className="date-starting mt-3" style={{fontSize:"14px"}}>
    //         {eventData?.description}
    //        </p>
    //     </div>}
    //   </div>
    //   <div className="fixed left-0 bottom-0 w-full bg-indigo-900">
    //     <div className="h-full  w-full app-wrapper-desktop  bg-indigo-900">
        
    //       <div className="w-full flex items-center justify-between p-5 section-wrap">
    //         <div className="rate flex items-center"><span className="price mr-1">
    //         {
    //             eventData?.offer ?
    //             <div className="flex item-center gap-3">
    //               <div className="line-through" style={{color:"#a69e9e"}}>₹{eventData?.rate}</div>
    //               <div>₹{handleOffers(eventData?.rate, parseInt(eventData?.offer))}</div>
    //             </div> 
    //               :<div> <span>₹</span> <span>{eventData?.rate}</span></div>
    //           }
    //            </span> Per Person</div>
    //         <button className="get-bookings" onClick={()=>handleGetTickets()}>Get Tickets</button>
    //       </div>
    //     </div>
    //   </div>
    //   {popUp&&<RedirectCommonModal heading="Login first to continue booking" link={"../hotel-list"} hide={()=>setPopUp(false)}/>}
    // </div>
    <div>hi</div>
    // <div className="pt-4 h-full relative event-data">
    //   <div className="section-wrap flex items-center w-full justify-between mb-4">
    //     <div className="flex items-center gap-3">
    //     <BackButton link="../"/>
    //     <div className="event-heading">Event</div>
    //     </div> 
    //     <RWebShare
    //       data={{
    //         // text: "Edaya Explore",
    //         url: currentUrl,
    //         // title: "Edaya | Guest Web App",
    //       }}
    //       onClick={() => console.log("shared successfully!")}
    //     >
    //     <button className="bg-white text-black px-3 text-sm py-2 flex items-center gap-3 rounded-2xl">Share <img className="w-4" src={ShareIcon} alt="" /></button>
    //   </RWebShare>
    //   </div>
    //   <div
    //     className="h-[240px] section-wrap w-full mx-auto sm:h-[300px] bg-cover bg-no-repeat"
    //     style={{
    //       background:
    //       eventData?.image ?
    //         `url(${eventData?.image})` : "gray",
    //         backgroundSize:"cover",
    //         backgroundRepeat:"no-repeat",
    //         maxWidth:"1334px", 
    //      }}
    //   ></div>
    //   <div className="mt-3 section-wrap pb-32">
    //     <div className="date-starting">{formatEventStartingDate(eventData?.from)}</div>
    //     <div className="event-main-head mt-2">
    //     {eventData?.name}
    //     </div>
    //     <div className="mt-4 flex gap-3">
    //       <img className="h-fit mt-1" src={calendarSvg} alt="" />
    //       <div className="date-starting" style={{fontSize:"14px"}}>{formatEventDateTime(eventData?.from)}<br/>
    //         <span>({formatEventDuration(eventData?.from,eventData?.to)})</span>
    //       </div>
    //      </div>
    //     <div className="mt-4 flex gap-3">
    //       <img className="h-fit mt-1" src={LocationSvg} alt="" />
    //       <div className="date-starting" style={{fontSize:"14px"}}>{eventData?.hotelName}</div>
    //     </div>
    //     <div className="mt-4 flex gap-3">
    //       <img className="h-fit w-5" src={ticketSvg} alt="" />
    //       <div className="date-starting" style={{fontSize:"14px"}}>Remaining Tickets: {remainingTickets}</div>
    //     </div>
    //    {eventData?.description && <div className="mt-4">
    //       <div className="sub-head">About this Event </div>

    //       <p className="date-starting mt-3" style={{fontSize:"14px"}}>
    //         {eventData?.description}
    //        </p>
    //     </div>}
    //   </div>
    //   <div className="fixed left-0 bottom-0 w-full bg-indigo-900">
    //     <div className="h-full  w-full app-wrapper-desktop  bg-indigo-900">

    //       <div className="w-full flex items-center justify-between p-5 section-wrap">
    //         <div className="rate flex items-center"><span className="price mr-1">
    //         {
    //             eventData?.offer ?
    //             <div className="flex item-center gap-3">
    //               <div className="line-through" style={{color:"#a69e9e"}}>₹{eventData?.rate}</div>
    //               <div>₹{handleOffers(eventData?.rate, parseInt(eventData?.offer))}</div>
    //             </div> 
    //               :<div> <span>₹</span> <span>{eventData?.rate}</span></div>
    //           }
    //            </span> Per Person</div>
    //         <button className="get-bookings" onClick={()=>handleGetTickets()}>Get Tickets</button>
    //       </div>
    //     </div>
    //   </div>
    //   {popUp&&<RedirectCommonModal heading="Login first to continue booking" link={"../hotel-list"} hide={()=>setPopUp(false)}/>}
    // </div>
    // <div>hi</div>
  );
}

export default EventDetails;
